import { AnyAction, Dispatch, MiddlewareAPI } from "redux";

import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { showProcessAssignmentModal } from "../../modules/assignment/actions";

/**
 * Zeigt das Modal für Vortragszuweisungen (nur verwendet im Popupmenu bei kleiner Ansicht)
 */
export function showAssignmentModalEventHandlerMiddleware(api: MiddlewareAPI) {
	return (next: Dispatch) => (action: AnyAction) => {
		next(action);
		if (FormEngineActions.event.match(action) && Events.eventButton.match(action.payload.engineEvent)) {
			const { engineEvent } = action.payload;
			if (Events.eventButton.match(engineEvent)) {
				if (engineEvent.payload.name === "changeAssignment") {
					api.dispatch(showProcessAssignmentModal({ activityId: action.payload.activityId }));
				}
			}
		}
	};
}

/**
 * Zeigt das Modal für Vortragszuweisungen (nur verwendet im Popupmenu bei kleiner Ansicht)
 */
export function showAssignmentModalMiddleware(api: MiddlewareAPI) {
	return (next: Dispatch) => (action: AnyAction) => {
		if (showProcessAssignmentModal.match(action)) {
			api.dispatch(
				ActivityActions.setData({
					activityId: action.payload.activityId,
					data: {
						...ActivitySelectors.data(action.payload.activityId),
						showAssignmentModal: true
					}
				})
			);
		}

		return next(action);
	};
}
export const assignmentModalMiddlewares = [showAssignmentModalEventHandlerMiddleware, showAssignmentModalMiddleware];
